import { AWARD_GRAPH_ICON, CHAT_USERS_ICON, SEARCH_PROFILES_MAGNIFIER } from '@utils/images';

const step1SVG = AWARD_GRAPH_ICON;
const step2SVG = CHAT_USERS_ICON;
const step3SVG = SEARCH_PROFILES_MAGNIFIER;

export const getSteps = t => [
  {
    image: step1SVG,
    text: t('vendor_onboarding.welcome.step_1_text'),
    title: t('vendor_onboarding.welcome.step_1_title'),
  },
  {
    image: step2SVG,
    text: t('vendor_onboarding.welcome.step_2_text'),
    title: t('vendor_onboarding.welcome.step_2_title'),
  },
  {
    image: step3SVG,
    text: t('vendor_onboarding.welcome.step_3_text'),
    title: t('vendor_onboarding.welcome.step_3_title'),
  },
];

export default getSteps;
